function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import * as glMatrix from 'gl-matrix';
import * as socketIoClient from 'socket.io-client';
import { ReactSVG as Svg } from 'react-svg';
import { deserializePreviewSuccessResponse, previewResponseSchema } from '@larki/shared/preview';
import shader from '../../shaders/previewTest.wgsl';
import { radians } from '../../utilities/math';
import { createGpuBufferFromFloat, createGpuBufferFromMat4, createGpuBufferFromVec2 } from '../../utilities/wgpu';
import classNames from 'classnames';
import text from '../../text';
function sphericalToCartesian(r, theta, phi) {
    var x = r * Math.sin(phi) * Math.cos(theta);
    var y = r * Math.sin(phi) * Math.sin(theta);
    var z = r * Math.cos(phi);
    return glMatrix.vec3.fromValues(x, y, z);
}
var _establishListeners = /*#__PURE__*/ new WeakSet();
var PreviewClient = /*#__PURE__*/ function() {
    "use strict";
    function PreviewClient() {
        _class_call_check(this, PreviewClient);
        _class_private_method_init(this, _establishListeners);
        _define_property(this, "socket", void 0);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.socket = socketIoClient.io(process.env.PREVIEW_SERVER_URL, {
            transports: [
                'websocket'
            ],
            path: '/ps',
            secure: true
        });
        _class_private_method_get(this, _establishListeners, establishListeners).call(this);
        console.log(':: client created');
    }
    _create_class(PreviewClient, [
        {
            key: "getPreview",
            value: function getPreview(id, lod, offset) {
                var _this = this;
                return _async_to_generator(function() {
                    var _raw, raw, _deserializePreviewSuccessResponse, xyz, rgb, extra, numPoints, data, rgbData, scaleFactor, i, i4, i3, j;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log(':: requesting preview');
                                return [
                                    4,
                                    _this.socket.emitWithAck('preview', {
                                        id: id,
                                        lod: lod
                                    })
                                ];
                            case 1:
                                _raw = _state.sent();
                                raw = previewResponseSchema.parse(_raw);
                                // error handling
                                if (raw.$status === 'error') {
                                    // safely handle not found case
                                    if (raw.$code === 'NOT_FOUND') {
                                        return [
                                            2,
                                            null
                                        ];
                                    }
                                    throw new Error(raw.error);
                                }
                                _deserializePreviewSuccessResponse = deserializePreviewSuccessResponse(raw), xyz = _deserializePreviewSuccessResponse.xyz, rgb = _deserializePreviewSuccessResponse.rgb, extra = _object_without_properties(_deserializePreviewSuccessResponse, [
                                    "xyz",
                                    "rgb"
                                ]);
                                if (!offset) {
                                    offset = extra.offset;
                                }
                                // 3 bytes for xyz data, 1 byte for rgb data
                                numPoints = xyz.length / 3;
                                data = new Float32Array(numPoints * 4);
                                // clever space-efficient way of packing rgb data into same buffer
                                // https://webgpufundamentals.org/webgpu/lessons/webgpu-vertex-buffers.html
                                rgbData = new Uint8Array(data.buffer);
                                scaleFactor = 1 / 65535;
                                for(i = 0; i < numPoints; i++){
                                    i4 = i * 4;
                                    i3 = i * 3;
                                    data[i4 + 0] = xyz[i3 + 0] * scaleFactor + offset[0];
                                    data[i4 + 1] = xyz[i3 + 1] * scaleFactor + offset[1];
                                    data[i4 + 2] = xyz[i3 + 2] * scaleFactor + offset[2];
                                    j = i * 16 + 12;
                                    rgbData[j + 0] = rgb[i3 + 0];
                                    rgbData[j + 1] = rgb[i3 + 1];
                                    rgbData[j + 2] = rgb[i3 + 2];
                                }
                                return [
                                    2,
                                    {
                                        buffer: data,
                                        offset: offset
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PreviewClient;
}();
function establishListeners() {
    var _this = this;
    this.socket.on('connect', function() {
        console.log(":: connected with transport ".concat(_this.socket.io.engine.transport.name));
    });
    this.socket.on('connect_error', function(error) {
        console.error(':: connect_error', error);
    });
    this.socket.on('disconnect', function(reason) {
        console.log(':: disconnect', reason);
    });
}
// by creating the client here we know there is only one
var client = new PreviewClient();
// WGPU \/
var UP = glMatrix.vec3.fromValues(0, 0, 1);
var ZERO = glMatrix.vec3.zero(glMatrix.vec3.create());
var FOVY = radians(80);
var NEAR = 0.01;
var FAR = 5;
var TIME_TO_360 = 30;
var RADIUS = 0.2;
var PHI = radians(45);
var DEFAULT_POINT_SIZE = 2;
var generateViewMatrix = function(eye) {
    var viewMatrix = glMatrix.mat4.lookAt(glMatrix.mat4.create(), eye, ZERO, UP);
    return viewMatrix;
};
var generateProjectionMatrix = function(aspectRatio) {
    var projectionMatrix = glMatrix.mat4.perspective(glMatrix.mat4.create(), FOVY, aspectRatio, NEAR, FAR);
    return projectionMatrix;
};
var prepareTimestampQuery = function(device) {
    var querySet = device.createQuerySet({
        type: 'timestamp',
        count: 2
    });
    var resolveBuffer = device.createBuffer({
        size: querySet.count * 8,
        usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
    });
    var resultBuffer = device.createBuffer({
        size: resolveBuffer.size,
        usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
    });
    return {
        querySet: querySet,
        resolveBuffer: resolveBuffer,
        resultBuffer: resultBuffer
    };
};
export var PreviewProvider = function(param) {
    var children = param.children;
    // fundamental error; if this happens no previews can be shown
    var _useState = _sliced_to_array(useState(null), 2), wgpuError = _useState[0], setWgpuError = _useState[1];
    // const frameRef = useRef<number | null>(null);
    // const infoRef = useRef<HTMLPreElement>(null);
    var _useState1 = _sliced_to_array(useState(new Map()), 2), id2Status = _useState1[0], setId2Status = _useState1[1];
    // UID: unique ID that is constant for the lifetime of the component
    // ID: non-unique ID used to query preview from the server
    //  two <Preview />s may have the same ID e.g. one small preview and aonther full-screen preview
    var canvas2Id = useRef(new Map());
    var previewData = useRef(new Map());
    var _useState2 = _sliced_to_array(useState(null), 2), wgpuDevice = _useState2[0], setWgpuDevice = _useState2[1];
    var _useState3 = _sliced_to_array(useState(new Set()), 2), _previews = _useState3[0], _setPreviews = _useState3[1];
    var t0 = useRef(null);
    var _init = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(device) {
            var canvases, bindGroupLayout, format, resizeObserver, visibleCanvases, intersectionObserver, canvas2Info, shaderModule, pipelineLayout, pipeline, frameRef, lastFrameTime, FRAME_DURATION, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, canvas;
            function render() {
                var now = performance.now();
                var deltaTime = now - lastFrameTime;
                if (deltaTime < FRAME_DURATION) {
                    frameRef = requestAnimationFrame(render);
                    return;
                }
                lastFrameTime = now;
                if (!canvas2Info.size) throw new Error('No infos found');
                var commandEncoder = device.createCommandEncoder();
                // const now = performance.now();
                // const renderStartTime = now;
                // const deltaTime = now - then;
                // then = now;
                if (!t0.current) t0.current = performance.now();
                var elapsed = (performance.now() - t0.current) / 1000;
                var percent = elapsed % TIME_TO_360 / TIME_TO_360;
                var theta = percent * 2 * Math.PI;
                var eye = sphericalToCartesian(RADIUS, theta, PHI);
                var viewMatrix = generateViewMatrix(eye);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // console.log(`render() :: visibleCanvases.size=${visibleCanvases.size} {initializationId=${initializationId}}`);
                    for(var _iterator = canvas2Info.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), canvas = _step_value[0], _step_value_ = _step_value[1], context = _step_value_.context, viewMatrixBuffer = _step_value_.viewMatrixBuffer, depthTextureView = _step_value_.depthTextureView, bindGroup = _step_value_.bindGroup;
                        // ignore canvases not in viewport
                        if (!visibleCanvases.has(canvas)) continue;
                        // ignore canvases that are paused
                        if (canvas.getAttribute('data-pause') === 'true') continue;
                        var id = canvas2Id.current.get(canvas);
                        if (!id) continue;
                        var vertexBuffer = previewData.current.get(id);
                        if (!vertexBuffer || vertexBuffer.$status !== 'success') continue;
                        device.queue.writeBuffer(viewMatrixBuffer, 0, new Float32Array(viewMatrix));
                        var passDescriptor = {
                            colorAttachments: [
                                {
                                    view: context.getCurrentTexture().createView(),
                                    clearValue: [
                                        0.1,
                                        0.2,
                                        0.3,
                                        1
                                    ],
                                    loadOp: 'clear',
                                    storeOp: 'store'
                                }
                            ],
                            depthStencilAttachment: {
                                view: depthTextureView,
                                depthClearValue: 1,
                                depthLoadOp: 'clear',
                                depthStoreOp: 'store'
                            }
                        };
                        var passEncoder = commandEncoder.beginRenderPass(passDescriptor);
                        passEncoder.setPipeline(pipeline);
                        passEncoder.setBindGroup(0, bindGroup);
                        passEncoder.setVertexBuffer(0, vertexBuffer.buffer);
                        passEncoder.draw(6, vertexBuffer.numPoints);
                        passEncoder.end();
                    // submit = true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // if (submit) {
                device.queue.submit([
                    commandEncoder.finish()
                ]);
                // }
                // if (canTimestamp) {
                //   if (!querySet)
                //     throw new Error('querySet undefined despite canTimestamp');
                //   passDescriptor.timestampWrites = {
                //     querySet,
                //     beginningOfPassWriteIndex: 0,
                //     endOfPassWriteIndex: 1,
                //   };
                // }
                // passEncoder.setViewport(
                //   0,
                //   0,
                //   canvasRef.current.width,
                //   canvasRef.current.height,
                //   0,
                //   1
                // );
                // if (canTimestamp) {
                //   if (!querySet || !resolveBuffer || !resultBuffer)
                //     throw new Error('unreachable');
                //   // take the results of the query and puts them into resolve buffer
                //   commandEncoder.resolveQuerySet(
                //     querySet,
                //     0,
                //     querySet.count,
                //     resolveBuffer,
                //     0
                //   );
                //   if (resultBuffer.mapState === 'unmapped') {
                //     // copy resolveBuffer to resultBuffer
                //     commandEncoder.copyBufferToBuffer(
                //       resolveBuffer,
                //       0,
                //       resultBuffer,
                //       0,
                //       resultBuffer.size
                //     );
                //   }
                // }
                //         if (canTimestamp) {
                //           if (!resultBuffer) throw new Error('unreachable');
                //           if (resultBuffer.mapState === 'unmapped') {
                //             resultBuffer.mapAsync(GPUMapMode.READ).then(() => {
                //               const times = new BigInt64Array(resultBuffer.getMappedRange());
                //               gpuTime = Number(times[1] - times[0]);
                //               gpuAverage.addSample(gpuTime / 1000);
                //               resultBuffer.unmap();
                //             });
                //           }
                //         }
                //         const jsTime = performance.now() - renderStartTime;
                //         fpsAverage.addSample(1000 / deltaTime);
                //         jsAverage.addSample(jsTime);
                //         if (infoRef.current) {
                //           infoRef.current.textContent = `\
                // fps: ${fpsAverage.get().toFixed(1)}
                // js: ${jsAverage.get().toFixed(1)}ms
                // gpu: ${canTimestamp ? `${gpuAverage.get().toFixed(1)}µs` : 'N/A'}
                // `;
                //         }
                frameRef = requestAnimationFrame(render);
            }
            return _ts_generator(this, function(_state) {
                // get all canvases with data-preview attribute
                canvases = Array.from(document.querySelectorAll('canvas[data-preview]')).filter(function(el) {
                    return _instanceof(el, HTMLCanvasElement);
                });
                if (!canvases.length) {
                    console.warn('wgpu() :: no canvases found');
                    return [
                        2,
                        function() {}
                    ];
                }
                // bind group layout
                bindGroupLayout = device.createBindGroupLayout({
                    entries: [
                        // projection
                        {
                            binding: 0,
                            visibility: GPUShaderStage.VERTEX,
                            buffer: {
                                type: 'uniform'
                            }
                        },
                        // view
                        {
                            binding: 1,
                            visibility: GPUShaderStage.VERTEX,
                            buffer: {
                                type: 'uniform'
                            }
                        },
                        // point size
                        {
                            binding: 2,
                            visibility: GPUShaderStage.VERTEX,
                            buffer: {
                                type: 'uniform'
                            }
                        },
                        // resolution
                        {
                            binding: 3,
                            visibility: GPUShaderStage.VERTEX,
                            buffer: {
                                type: 'uniform'
                            }
                        }
                    ]
                });
                format = navigator.gpu.getPreferredCanvasFormat();
                // canvas resizing
                // source: https://webgpufundamentals.org/webgpu/lessons/webgpu-resizing-the-canvas.html
                resizeObserver = new ResizeObserver(function(entries) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // wrapping in requestAnimationFrame fixes resize errors; not sure why... https://github.com/floating-ui/floating-ui/issues/1740#issuecomment-1156101678
                        // requestAnimationFrame(() => {
                        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            var _entry_devicePixelContentBoxSize, _entry_devicePixelContentBoxSize1;
                            var width = ((_entry_devicePixelContentBoxSize = entry.devicePixelContentBoxSize) === null || _entry_devicePixelContentBoxSize === void 0 ? void 0 : _entry_devicePixelContentBoxSize[0].inlineSize) || entry.contentBoxSize[0].inlineSize * devicePixelRatio;
                            var height = ((_entry_devicePixelContentBoxSize1 = entry.devicePixelContentBoxSize) === null || _entry_devicePixelContentBoxSize1 === void 0 ? void 0 : _entry_devicePixelContentBoxSize1[0].blockSize) || entry.contentBoxSize[0].blockSize * devicePixelRatio;
                            var canvas = entry.target;
                            if (!_instanceof(canvas, HTMLCanvasElement)) throw new Error('expected canvas');
                            canvas.width = Math.max(1, Math.min(width, device.limits.maxTextureDimension2D));
                            canvas.height = Math.max(1, Math.min(height, device.limits.maxTextureDimension2D));
                            var info = canvas2Info.get(canvas);
                            if (!info) return;
                            info.depthTexture.destroy();
                            // const resolution = [canvas.width, canvas.height] as const;
                            // device.queue.writeBuffer(
                            //   resolutionBuffer,
                            //   0,
                            //   new Float32Array(resolution)
                            // );
                            // if (depthTexture) {
                            //   depthTexture.destroy();
                            // }
                            info.depthTexture = device.createTexture({
                                size: {
                                    width: canvas.width,
                                    height: canvas.height
                                },
                                format: 'depth24plus',
                                usage: GPUTextureUsage.RENDER_ATTACHMENT
                            });
                            info.depthTextureView = info.depthTexture.createView();
                        // if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
                        // frameRef.current = requestAnimationFrame(render);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                // });
                });
                visibleCanvases = new Set();
                intersectionObserver = new IntersectionObserver(function(entries) {
                    console.log('test');
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            if (!_instanceof(entry.target, HTMLCanvasElement)) continue;
                            if (entry.isIntersecting) {
                                visibleCanvases.add(entry.target);
                            } else {
                                visibleCanvases.delete(entry.target);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
                canvas2Info = new Map(canvases.map(function(canvas) {
                    var context = canvas.getContext('webgpu');
                    if (!context) throw new Error('No webgpu context found');
                    context.configure({
                        device: device,
                        format: format,
                        usage: GPUTextureUsage.RENDER_ATTACHMENT,
                        alphaMode: 'opaque'
                    });
                    // constant, UNCHANGING attributes; making this reactive is additional work
                    var attrs = {
                        pointSize: canvas.getAttribute('data-point-size')
                    };
                    var pointSize = attrs.pointSize ? parseFloat(attrs.pointSize) : DEFAULT_POINT_SIZE;
                    // projection matrix
                    var aspectRatio = canvas.width / canvas.height;
                    var projectionMatrix = generateProjectionMatrix(aspectRatio);
                    var projectionMatrixBuffer = createGpuBufferFromMat4(device, projectionMatrix, GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST);
                    // view matrix
                    var eye = sphericalToCartesian(RADIUS, 0, PHI);
                    var viewMatrix = generateViewMatrix(eye);
                    var viewMatrixBuffer = createGpuBufferFromMat4(device, viewMatrix, GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST);
                    // point size
                    var pointSizeBuffer = createGpuBufferFromFloat(device, pointSize, GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST);
                    // resolution
                    var resolution = [
                        canvas.width,
                        canvas.height
                    ];
                    var resolutionBuffer = createGpuBufferFromVec2(device, resolution, GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST);
                    // bind group
                    var bindGroup = device.createBindGroup({
                        layout: bindGroupLayout,
                        entries: [
                            {
                                binding: 0,
                                resource: {
                                    buffer: projectionMatrixBuffer
                                }
                            },
                            {
                                binding: 1,
                                resource: {
                                    buffer: viewMatrixBuffer
                                }
                            },
                            {
                                binding: 2,
                                resource: {
                                    buffer: pointSizeBuffer
                                }
                            },
                            {
                                binding: 3,
                                resource: {
                                    buffer: resolutionBuffer
                                }
                            }
                        ]
                    });
                    var depthTexture = device.createTexture({
                        size: {
                            width: canvas.width,
                            height: canvas.height
                        },
                        format: 'depth24plus',
                        usage: GPUTextureUsage.RENDER_ATTACHMENT
                    });
                    var depthTextureView = depthTexture.createView();
                    return [
                        canvas,
                        {
                            canvas: canvas,
                            context: context,
                            projectionMatrixBuffer: projectionMatrixBuffer,
                            viewMatrixBuffer: viewMatrixBuffer,
                            pointSizeBuffer: pointSizeBuffer,
                            resolutionBuffer: resolutionBuffer,
                            bindGroup: bindGroup,
                            depthTexture: depthTexture,
                            depthTextureView: depthTextureView
                        }
                    ];
                }));
                // shader module
                shaderModule = device.createShaderModule({
                    code: shader
                });
                // pipeline layout
                pipelineLayout = device.createPipelineLayout({
                    bindGroupLayouts: [
                        bindGroupLayout
                    ]
                });
                // pipeline
                pipeline = device.createRenderPipeline({
                    layout: pipelineLayout,
                    vertex: {
                        module: shaderModule,
                        entryPoint: 'vs_main',
                        buffers: [
                            // instance data
                            {
                                arrayStride: 3 * 4 + 4,
                                stepMode: 'instance',
                                attributes: [
                                    {
                                        shaderLocation: 0,
                                        format: 'float32x3',
                                        offset: 0
                                    },
                                    {
                                        shaderLocation: 1,
                                        format: 'unorm8x4',
                                        offset: 3 * 4
                                    }
                                ]
                            }
                        ]
                    },
                    fragment: {
                        module: shaderModule,
                        entryPoint: 'fs_main',
                        targets: [
                            {
                                format: format
                            }
                        ]
                    },
                    primitive: {
                        topology: 'triangle-list',
                        cullMode: 'back',
                        frontFace: 'ccw'
                    },
                    depthStencil: {
                        depthWriteEnabled: true,
                        depthCompare: 'less-equal',
                        format: 'depth24plus'
                    }
                });
                // const { querySet, resolveBuffer, resultBuffer } = canTimestamp
                //   ? prepareTimestampQuery(device)
                //   : {};
                // const fpsAverage = new NonNegativeRollingAverage();
                // const jsAverage = new NonNegativeRollingAverage();
                // const gpuAverage = new NonNegativeRollingAverage();
                // let t0: number | null = null;
                // let then = 0;
                // let gpuTime = 0;
                // let first = true;
                frameRef = null;
                lastFrameTime = 0;
                FRAME_DURATION = 1000 / 30; // 15 fps
                frameRef = requestAnimationFrame(render);
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(_iterator = canvas2Info.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        _step_value = _sliced_to_array(_step.value, 1), canvas = _step_value[0];
                        try {
                            resizeObserver.observe(canvas, {
                                box: 'device-pixel-content-box'
                            });
                        } catch (e) {
                            resizeObserver.observe(canvas, {
                                box: 'content-box'
                            });
                        }
                        intersectionObserver.observe(canvas);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    2,
                    function() {
                        if (frameRef !== null) cancelAnimationFrame(frameRef);
                    }
                ];
            });
        });
        return function(device) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    /**
   * Initialize everything WGPU-related.
   * NOTE: all <Preview /> components must be rendered but not necessarily visible.
   * So if they are behind a popup, make sure opening/closing that popup is a matter of changing it's visibility, not removing/adding it to the DOM.
   */ useEffect(function() {
        var wgpu = function wgpu() {
            return _wgpu.apply(this, arguments);
        };
        function _wgpu() {
            _wgpu = _async_to_generator(function() {
                var adapter, canTimestamp, device;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!navigator.gpu) throw new Error('WebGPU not supported in this browser');
                            return [
                                4,
                                navigator.gpu.requestAdapter()
                            ];
                        case 1:
                            adapter = _state.sent();
                            if (!adapter) throw new Error('No adapter found');
                            canTimestamp = adapter.features.has('timestamp-query');
                            return [
                                4,
                                adapter === null || adapter === void 0 ? void 0 : adapter.requestDevice({
                                    requiredFeatures: _to_consumable_array(canTimestamp ? [
                                        'timestamp-query'
                                    ] : [])
                                })
                            ];
                        case 2:
                            device = _state.sent();
                            device.addEventListener('uncapturederror', function(event) {
                                throw event.error;
                            });
                            window.addEventListener('error', function(e) {
                                console.error('window.error', e.message);
                            });
                            setWgpuDevice(device);
                            return [
                                2
                            ];
                    }
                });
            });
            return _wgpu.apply(this, arguments);
        }
        wgpu().catch(function(error) {
            setWgpuError(error);
        });
    }, [
        _init
    ]);
    /**
   * Load a preview.
   * We pass in the device by argument here as assurance that the device is available.
   */ var load = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(device, canvas, id) {
            var data, buffer, numPoints, vertexBuffer, xyzArray;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        canvas2Id.current.set(canvas, id);
                        if (previewData.current.has(id)) return [
                            2
                        ]; // load ONCE only
                        previewData.current.set(id, {
                            $status: 'loading'
                        });
                        setId2Status(function(prev) {
                            return new Map(prev).set(id, 'loading');
                        });
                        return [
                            4,
                            client.getPreview(id, 0)
                        ];
                    case 1:
                        data = _state.sent();
                        // preview unavailable
                        if (!data) {
                            previewData.current.set(id, {
                                $status: 'unavailable'
                            });
                            // to trigger a re-render, creating a new object is *required*, source: https://react.dev/learn/updating-objects-in-state
                            setId2Status(function(prev) {
                                return new Map(prev).set(id, 'unavailable');
                            });
                            return [
                                2
                            ];
                        }
                        // preview available
                        buffer = data.buffer;
                        numPoints = buffer.length / 4;
                        console.log("load() :: numPoints=".concat(numPoints));
                        vertexBuffer = device.createBuffer({
                            size: buffer.byteLength,
                            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
                            mappedAtCreation: true
                        });
                        xyzArray = new Float32Array(vertexBuffer.getMappedRange());
                        xyzArray.set(buffer);
                        vertexBuffer.unmap();
                        previewData.current.set(id, {
                            $status: 'success',
                            buffer: vertexBuffer,
                            numPoints: numPoints
                        });
                        setId2Status(function(prev) {
                            return new Map(prev).set(id, 'success');
                        });
                        return [
                            2
                        ];
                }
            });
        // TODO: load higher LOD
        // client
        //   .getPreview(KEY, 1, offset)
        //   .then(async (data) => {
        //     if (!data) return;
        //     const { buffer } = data;
        //     await new Promise((resolve) => setTimeout(resolve, 1000));
        //     vertexBuffer.destroy();
        //     numPoints = buffer.length / 4;
        //     console.log('numPoints', numPoints);
        //     vertexBuffer = device.createBuffer({
        //       size: buffer.byteLength,
        //       usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
        //       mappedAtCreation: true,
        //     });
        //     const xyzArray = new Float32Array(vertexBuffer.getMappedRange());
        //     xyzArray.set(buffer);
        //     vertexBuffer.unmap();
        //   })
        //   .catch((err) => {
        //     throw err;
        //   });
        });
        return function(device, canvas, id) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var addPreview = useCallback(function(id) {
        _setPreviews(function(prev) {
            return new Set(_to_consumable_array(prev).concat([
                id
            ]));
        });
    }, []);
    var removePreview = useCallback(function(id) {
        _setPreviews(function(prev) {
            return new Set(_to_consumable_array(prev).filter(function(i) {
                return i !== id;
            }));
        });
    }, []);
    useEffect(function() {
        if (wgpuDevice) _init(wgpuDevice);
    }, [
        _init,
        _previews,
        wgpuDevice
    ]);
    return /*#__PURE__*/ React.createElement(PreviewContext.Provider, {
        value: {
            wgpuDevice: wgpuDevice,
            wgpuError: wgpuError,
            load: load,
            id2Status: id2Status,
            addPreview: addPreview,
            removePreview: removePreview
        }
    }, children);
};
var PreviewContext = /*#__PURE__*/ createContext(null);
export var Preview = function(param) {
    var id = param.id, pointSize = param.pointSize, _param_pause = param.pause, pause = _param_pause === void 0 ? false : _param_pause;
    var canvasRef = useRef(null);
    var _useContext = useContext(PreviewContext), wgpuDevice = _useContext.wgpuDevice, load = _useContext.load, id2Status = _useContext.id2Status, addPreview = _useContext.addPreview, removePreview = _useContext.removePreview;
    var status = useMemo(function() {
        return id ? id2Status.get(id) : null;
    }, [
        id,
        id2Status
    ]);
    useEffect(function() {
        if (wgpuDevice && id && canvasRef.current) load(wgpuDevice, canvasRef.current, id);
    }, [
        id,
        load,
        wgpuDevice
    ]);
    useEffect(function() {
        if (!id) return function() {};
        addPreview(id);
        return function() {
            return removePreview(id);
        };
    }, [
        addPreview,
        id,
        removePreview
    ]);
    if (status === 'unavailable') return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames('preview', status === 'loading' && 'loading')
    }, status === 'loading' ? /*#__PURE__*/ React.createElement("div", {
        className: "preview__loading"
    }, /*#__PURE__*/ React.createElement(Svg, {
        src: "/public/img/larki-logo-preview.svg"
    }), /*#__PURE__*/ React.createElement("p", null, text('loadingPreview'))) : null, /*#__PURE__*/ React.createElement("canvas", {
        "data-preview": true,
        "data-preview-id": id,
        "data-point-size": pointSize,
        "data-pause": pause,
        ref: canvasRef
    }));
};
